<template>
  <v-dialog v-model="showForm" scrollable max-width="580px" @click:outside="onCancelClick">
    <template v-slot:activator="{ on, attrs }">
      <!--addXLOutlined-->
      <v-btn v-if="buttonType === 'addXLOutlined'" :disabled="disabledBtn" color="secondary" 
      rounded class="elevation-0 monospace-font white--text" v-bind="attrs" v-on="on" 
      > 
        <v-icon>add</v-icon>{{ $t("general.addNew") }} 
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="secondary white--text d-flex align-center justify-space-between">
        <span cclass="header-font" style="font-size: 22px;">
          <v-icon lstyle="font-size: 18px;" color="white" class="mr-2">add</v-icon>
          {{ $t("videoUpload.newPlayer") }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-row align="center" class="pa-3">
          <!--Name-->
          <v-col cols="12" md="6" class="pa-0">
            <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('settings.contactData.firstName') }}</p>
            <v-text-field class="me-1 slim-input" dense outlined v-model="player.firstName"
              :hint="$t('scoutingCalendar.tasks.accommodation.required')" :persistent-hint="!player.firstName"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="pa-0">
            <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('settings.contactData.lastName') }}</p>
            <v-text-field class="slim-input ms-1" dense outlined 
            v-model="player.secondName" :hint="$t('scoutingCalendar.tasks.accommodation.required')" :persistent-hint="!player.secondName"></v-text-field>
          </v-col>
           <!--Positions-->
          <v-col cols="12" md="6" class="pa-0">
            <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('playerScout.position') }}</p>
            <v-select class="me-1 slim-input" dense outlined clearable :items="positions" 
              v-model="player.fieldPositionId" :hint="$t('scoutingCalendar.tasks.accommodation.required')" :persistent-hint="!player.fieldPositionId">
              <template v-slot:selection="{item}"><v-chip small :color="getPositionChip(item)" class="body-2 my-1 monospace-font">{{ getPositionCode(item) }}</v-chip></template>
              <template v-slot:item="{item}"><v-chip small :color="getPositionChip(item)" class="body-2 my-1 monospace-font">{{ getPositionCode(item) }}</v-chip></template>
            </v-select>
          </v-col>
          <v-col cols="12" md="6" class="pa-0">
            <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('playerScout.secondPos') }}</p>
            <v-select class="slim-input ms-1" dense outlined clearable :items="positions" v-model="player.secondFieldPositionId">
              <template v-slot:selection="{item}"><v-chip small :color="getPositionChip(item)" class="body-2 my-1 monospace-font">{{ getPositionCode(item) }}</v-chip></template>
              <template v-slot:item="{item}"><v-chip small :color="getPositionChip(item)" class="body-2 my-1 monospace-font">{{ getPositionCode(item) }}</v-chip></template>
            </v-select>
          </v-col>
           <!--Height & weight-->
           <v-col cols="12" md="6" class="pa-0">
            <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('playerDetail.height') }}</p>
            <v-text-field class="slim-input me-1" type="number" dense outlined v-model="player.height" hide-details></v-text-field>
           </v-col>
           <v-col cols="12" md="6" class="pa-0">
            <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('playerDetail.weight') }}</p>
            <v-text-field class="slim-input ms-1" type="number" dense outlined v-model="player.weight" hide-details></v-text-field>
           </v-col>
           <!--Country-->
           <v-col cols="12" md="6" class="pa-0 mt-2">
            <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('playerScout.countryName') }}</p>
            <v-autocomplete class="slim-input me-1" dense outlined clearable hide-details
              v-model="player.countryId" 
              :items="nations" 
              item-text="textTranslated" 
              item-value="id"
            >
              <template v-slot:selection="{item}">
                <v-card-text class="pa-0 primary--text body-2 font-weight-medium d-flex align-center text-ellipsis" style="max-width: 70px">
                  <DriblabCountryFlag :iso="item.code" v-if="item.code" size="small"></DriblabCountryFlag>
                  <span class="ml-2 text-ellipsis">{{ item.textTranslated }}</span>
                </v-card-text>
              </template>
              <template v-slot:item="{item}">
                <v-card-text class="pa-0 primary--text body-2 font-weight-medium d-flex align-center text-ellipsis" style="max-width: 70px">
                  <DriblabCountryFlag :iso="item.code" v-if="item.code" size="small"></DriblabCountryFlag>
                  <span class="ml-2 text-ellipsis">{{ item.textTranslated }}</span>
                </v-card-text>
              </template>
            </v-autocomplete>
           </v-col>
           <v-col cols="12" md="6" class="pa-0 mt-2">
            <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('playerScout.secondCountryName') }}</p>
            <v-autocomplete class="slim-input ms-1" dense outlined clearable hide-details
              v-model="player.secondCountryId" 
              :items="nations" 
              item-text="textTranslated" 
              item-value="id"
            >
              <template v-slot:selection="{item}">
                <v-card-text class="pa-0 primary--text body-2 font-weight-medium d-flex align-center text-ellipsis" style="max-width: 70px">
                  <DriblabCountryFlag :iso="item.code" v-if="item.code" size="small"></DriblabCountryFlag>
                  <span class="ml-2 text-ellipsis">{{ item.textTranslated }}</span>
                </v-card-text>
              </template>
              <template v-slot:item="{item}">
                <v-card-text class="pa-0 primary--text body-2 font-weight-medium d-flex align-center text-ellipsis" style="max-width: 70px">
                  <DriblabCountryFlag :iso="item.code" v-if="item.code" size="small"></DriblabCountryFlag>
                  <span class="ml-2 text-ellipsis">{{ item.textTranslated }}</span>
                </v-card-text>
              </template>
            </v-autocomplete>
           </v-col>
           <!--Male and DOB-->
           <v-col cols="12" md="4" class="pa-0 mt-2">
            <v-checkbox v-model="player.isMale" color="secondary" hide-details dense class="flex-grow-1 ma-0 pa-0">
              <template v-slot:label>
                <span class="body-1 primary--text">{{ $t('general.male') }}</span>
              </template>
            </v-checkbox>
           </v-col>
           <v-col cols="12" md="8" class="pa-0 mt-2">
            <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('playerScout.dob') }}</p>
            <v-menu v-model="showSelectDob" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field readonly v-bind="attrs" v-on="on" hide-details class="pt-0 mt-0 slim-input"
                  v-model="player.dob" clearable outlined
                ></v-text-field>
              </template>
              <v-date-picker no-title color="secondary"
                v-model="player.dob" 
                :locale="currentUserLanguage" 
                :first-day-of-week="1" 
                @change="showSelectDob = false"
              >
              </v-date-picker>
            </v-menu>
           </v-col>
           <!--Team-->
           <v-col cols="9" class="pa-0 mt-2">
            <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('general.team') }}</p>
            <v-autocomplete class="me-2 slim-input" dense outlined clearable 
              :hint="$t('scoutingCalendar.tasks.accommodation.required')" :persistent-hint="!player.teamId && !showTeamForm"
              :items="teams" 
              item-text="name" 
              item-value="id" 
              v-model="player.teamId"
              :disabled="showTeamForm"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="3" class="pa-0 mt-2">
            <v-btn x-small :disabled="!!player.teamId" color="secondary" rounded class="monospace-font elevation-0 py-3" 
              @click="handleShowTeamForm()"><v-icon>add</v-icon>{{ $t("general.addNew") }}</v-btn>
          </v-col>
        </v-row>
        <v-card v-if="showTeamForm" outlined class="px-3">
          <v-card-title class="pa-0 ma-0"><span class="h3 font-weight-bold mt-2">{{ $t('general.team') }}</span></v-card-title>
          <v-row align="center" class="pa-3">
            <!--Team name-->
            <v-col cols="12" class="pa-0">
              <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('playerDetail.name') }}</p>
              <v-text-field class="slim-input me-1" dense outlined hide-details
                v-model="team.teamName" :hint="$t('scoutingCalendar.tasks.accommodation.required')" :persistent-hint="!team.teamName"></v-text-field>
            </v-col>
            <!--Team alias and country-->
            <v-col cols="12" md="6" class="pa-0 mt-2">
              <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('general.alias') }}</p>
              <v-text-field class="slim-input me-1" dense outlined counter maxlength="3"
              v-model="team.alias" :hint="$t('scoutingCalendar.tasks.accommodation.required')" :persistent-hint="!team.alias"></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pa-0 mt-2">
              <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('playerScout.countryName') }}</p>
              <v-autocomplete class="slim-input ms-1" dense outlined clearable
                v-model="team.countryId" 
                :items="nations" 
                item-text="textTranslated" 
                item-value="id"
              >
                <template v-slot:selection="{item}">
                  <v-card-text class="pa-0 primary--text body-2 font-weight-medium d-flex align-center text-ellipsis" style="max-width: 70px">
                    <DriblabCountryFlag :iso="item.code" v-if="item.code" size="small"></DriblabCountryFlag>
                    <span class="ml-2 text-ellipsis">{{ item.textTranslated }}</span>
                  </v-card-text>
                </template>
                <template v-slot:item="{item}">
                  <v-card-text class="pa-0 primary--text body-2 font-weight-medium d-flex align-center text-ellipsis" style="max-width: 70px">
                    <DriblabCountryFlag :iso="item.code" v-if="item.code" size="small"></DriblabCountryFlag>
                    <span class="ml-2 text-ellipsis">{{ item.textTranslated }}</span>
                  </v-card-text>
                </template>
              </v-autocomplete>
            </v-col>
            <!--Team checkboxes-->
            <v-col cols="12" class="pa-0 d-flex align-center justify-space-around">
              <v-checkbox class="mt-0" v-model="team.youthTeam" :label="$t('general.youth')" hide-details dense color="secondary">
                <template v-slot:label>
                  <span class="body-1 primary--text">{{ $t('general.youth') }}</span>
                </template>
              </v-checkbox>
              <v-checkbox class="mt-0" v-model="team.bTeam" :label="'B Team'" hide-details dense color="secondary">
                <template v-slot:label>
                  <span class="body-1 primary--text">B Team</span>
                </template>
              </v-checkbox>
            </v-col>
            <!--Parent team & age limit-->
            <v-col cols="12" md="6" class="pa-0 mt-2" v-if="team.youthTeam || team.bTeam" >
              <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('team.parentTeam') }}</p>
              <v-autocomplete class="me-1 slim-input" :items="teams" item-text="name" item-value="id" 
                v-model="team.parentId" dense outlined clearable></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" class="pa-0 mt-2" v-if="team.youthTeam || team.bTeam">
              <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('playerScout.age') }}</p>
              <v-autocomplete class="slim-input ms-1" dense outlined clearable
                v-model="league.ageLimit" 
                :items="ageLimitItems" 
                item-text="label" item-value="value"
                :hint="$t('scoutingCalendar.tasks.accommodation.required')" :persistent-hint="!league.ageLimit"
              ></v-autocomplete>
            </v-col>
            <!--LEAGUE-->
            <v-col cols="9" class="pa-0 mt-2">
              <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('playerScout.league') }}</p>
              <v-autocomplete class="me-2 slim-input" dense outlined clearable return-object hide-details
                :items="leagues" 
                item-text="label" 
                item-value="id" 
                v-model="selectedLeague"
                :disabled="showLeagueForm"
              >
              <template v-slot:selection="{item}">
                <div class="d-flex align-center">
                  <img contain class="ml-3 mr-2 mt-1" height="16" :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/' + item.id + '.png'"
                    @error="onImageLoadFailure($event)" />
                  <span class="body-2"> {{ item.label }} </span>
                </div>
              </template>
              <template v-slot:item="{item}">
                <div class="d-flex align-center">
                  <img contain class="ml-3 mr-2 mt-1" height="16" :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/' + item.id + '.png'"
                    @error="onImageLoadFailure($event)" />
                  <span class="body-2"> {{ item.label }} </span>
                </div>
              </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="3" class="pa-0 mt-6">
              <v-btn x-small :disabled="!!selectedLeague" color="secondary" rounded class="monospace-font elevation-0 py-3"  
                @click="handleShowLeagueForm()"><v-icon>add</v-icon>{{ $t("general.addNew") }}</v-btn>
            </v-col>
            <!--LEAGUE form-->
            <v-row class="pa-0 ma-0" v-if="showLeagueForm">
              <v-col cols="12" class="pa-0 mt-2">
                <v-card-title class="pa-0 ma-0"><span class="h3 font-weight-bold mt-2">{{ $t('playerRecruitment.league') }}</span></v-card-title>
              </v-col>
              <!--League name-->
              <v-col cols="12" class="pa-0 mt-2">
                <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('playerDetail.name') }}</p>
                <v-text-field class="slim-input me-1" dense outlined 
                  v-model="league.name" :hint="$t('scoutingCalendar.tasks.accommodation.required')" :persistent-hint="!league.name"></v-text-field>
              </v-col>
              <!--Division and year-->
              <v-col cols="12" md="6" class="pa-0 mt-2">
                <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('general.division') }}</p>
                <v-select class="slim-input me-1" dense outlined :items="divisions" 
                  v-model="league.division" :hint="$t('scoutingCalendar.tasks.accommodation.required')" :persistent-hint="!league.division">
                </v-select>
              </v-col>
              <v-col cols="12" md="6" class="pa-0 mt-2">
                <p class="body-1 font-weight-bold primary--text mb-0">{{ $t('playerRecruitment.year') }}</p>
                <v-text-field ref="lastYearField" class="ms-1 slim-input" v-model="league.lastYear" dense outlined type="number" :min="2010" :max="2050"
                  :rules="yearRules" validate-on-blur :hint="$t('scoutingCalendar.tasks.accommodation.required')" :persistent-hint="!league.lastYear"></v-text-field>
              </v-col>
            </v-row>
            <!--No league warning-->
            <v-col cols="12" class="pa-0 mt-2"  v-if="(!showLeagueForm && !selectedLeague) || (showLeagueForm && (!league.name || !league.division || !league.lastYear))">          
              <v-alert dense type="warning" :border="'left'" class="mt-3 mb-0 py-1 body-2 font-weight-medium">
                {{ $t("addPlayerForm.noLeague") }}
              </v-alert>
            </v-col>
          </v-row>
        </v-card>
      </v-card-text>
      <!--Buttons-->
      <v-card-actions class="d-flex justify-end pa-6">
        <v-btn :color="$vuetify.theme.dark ? 'white' : 'secondary'" rounded outlined class="elevation-0 monospace-font px-4" @click="onCancelClick" :disabled="isSaving">{{$t('general.cancel')}}</v-btn>
        <v-btn rounded class="elevation-0 monospace-font white--text px-4" color="primary" @click="onSaveClick" :loading="isSaving" :disabled="canBeSaved">
          {{$t('general.save')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import * as _ from 'lodash';
import { getPositionCode, getChipColorByPosition } from '../../utils/functions';
import SearchBar from '../base/SearchBar.vue';
import CountryService from '../../services/country.service';
import LeagueService from '../../services/league.service';
import DriblabCountryFlag from '../base/DriblabCountryFlag.vue';
import TeamFormModal from '../base/TeamFormModal.vue';
import TeamService from '../../services/team/team.service';
import PlayerService from '../../services/player/player.service';
import SeasonService from '../../services/season.service';
import moment from 'moment';

export default {
  name: 'AddPlayerModal',
  props: {
    buttonType: {
      type: String,
      default: 'addXLOutlined' //Types: addXLButton, addXSButton, editButton, itemListButton
    },
    disabledBtn: {
      type: Boolean,
      default: false
    },
    dataSet: {
      type: Object,
      default: () => {}
    }
  },
  components: { 
    SearchBar, DriblabCountryFlag, TeamFormModal
  },
  data() {
    return {
      showForm: false,
      isSaving: false,
      player: { isMale: true },
      team: { nationalTeam: false, male: true, youthTeam: false, bTeam: false },
      league: { area: 13, endSameYear: false },
      season: { currentMatchday: 0, hasPhysicalData: false,  },
      positions: [1, 2, 3, 4, 5, 15, 16, 6, 7, 8, 9, 10, 11, 12, 13, 14],
      nations: [],
      showTeamForm: false,
      showLeagueForm: false,
      leagues: [],
      divisions: [1, 2, 3, 4, 5],
      selectedLeague: null,
      yearRules: [(v) => {
        const num = parseInt(v, 10);
        return (num >= 2010 && num <= 2050) || 'Year must be between 2010 and 2050';
      }],
      showSelectDob: false,
      ageLimitItems: [{ label: 'U10', value: 10 }, { label: 'U11', value: 11 }, { label: 'U12', value: 12 }, { label: 'U13', value: 13 }, { label: 'U14', value: 14 }, { label: 'U15', value: 15 }, { label: 'U16', value: 16 },
      { label: 'U17', value: 17 }, { label: 'U18', value: 18 }, { label: 'U19', value: 19 }, { label: 'U20', value: 20 }, { label: 'U21', value: 21 }, { label: 'U22', value: 22 }, { label: 'U23', value: 23 }],
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    darkMode(){
      return this.currentUser.darkMode || this.$vuetify.theme.dark;
    },
    requiredRules(){
      return [ v => !!v || this.$t("general.formErrors.required")];
    },
    teams() {
      return _.chain(this.dataSet.teams)
        .filter(t => t.aBC === this.currentUser.clientId)
        .orderBy('name', 'asc')
        .value();
    },
    canBeSaved() {
      if (!this.showTeamForm) {
        return !this.player.firstName || !this.player.secondName || !this.player.fieldPositionId || !this.player.teamId;
      } else if (this.showTeamForm && !this.showLeagueForm) {
        return !this.player.firstName || !this.player.secondName || !this.player.fieldPositionId || !this.team.teamName || !this.team.alias;
      } else if (this.showTeamForm && this.showLeagueForm) {
        return !this.player.firstName || !this.player.secondName || !this.player.fieldPositionId || !this.team.teamName || !this.team.alias 
          || !this.league.name || !this.league.division || !this.league.lastYear || !this.$refs.lastYearField.validate();
      };
    },
    currentUserLanguage() {
      return this.$store.getters["auth/language"];
    }
  },
  async created() {
    await this.loadNations();
    await this.loadLeagues();
  },
  mounted() {

  },
  methods: {
    onCancelClick() {
      this.$emit("dialogClosed", this.player);
      this.isSaving = false;
      this.showForm = !this.showForm;
    },
    async createNewLeague() {
      if (this.showLeagueForm) {
        this.league.countryId = this.team.countryId || 816; //id for "Unknown"
        this.league.isYouth = this.team.youthTeam;
        this.league.isMale = this.player.isMale;

        const addedLeague = await LeagueService.postLeague(this.league);
        if (addedLeague.data) this.league.id = addedLeague.data;
      };
    },
    async createNewSeason() {
      if (this.league.id) {
        this.season.name = `${this.league.name} ${this.league.lastYear}`;
        this.season.leagueId = this.league.id;
        this.season.leagueYear = this.league.lastYear;
        this.season.isActive = +this.league.lastYear === moment().year() || +this.league.lastYear === moment().year() - 1;
        this.season.startDate = moment(`01/08/${this.league.lastYear}`, "DD/MM/YYYY");
        this.season.endDate = moment(`30/05/${+this.league.lastYear + 1}`, "DD/MM/YYYY");
        
        const addedSeason = await SeasonService.postSeason(this.season);
        if (addedSeason.data) this.season.id = addedSeason.data;
      };
    },
    async createNewTeam() {
      if (this.showTeamForm) {
        this.team.seasonId = this.season.id;
        this.team.countryId = this.team.countryId || 816; //id for "Unknown"
        this.team.male = this.player.isMale;

        const addedTeam = await TeamService.postTeam(this.team);
        if (addedTeam.data) {
          this.team.id = addedTeam.data;
          this.player.teamId = addedTeam.data;
        };
      }
    },
    async createNewPlayer() {
      this.player.name = this.player.secondName ? `${this.player.firstName} ${this.player.secondName}` : this.player.firstName;
      this.player.teamId = this.player.teamId || this.team.id;
      this.player.countryId = this.player.countryId || 816; //id for "Unknown"
      this.player.secondCountryId = this.player.secondCountryId || 816; //id for "Unknown"
      this.player.weight = this.player.weight ? this.player.weight : 0;
      this.player.height = this.player.height ? this.player.height : 0;
      if (this.player.dob) this.player.age = this.calculatePlayerAge(this.player.dob);

      const addedPlayer = await PlayerService.postPlayer(this.player);

      if (addedPlayer.data) this.player.id = addedPlayer.data;
    },
    async onSaveClick() {
      this.isSaving = true;
      await this.createNewLeague();
      await this.createNewSeason();
      await this.createNewTeam();
      await this.createNewPlayer();
      this.isSaving = false;
      if (this.player.id) this.onCancelClick();
    },
    getPositionChip(position) {
      return getChipColorByPosition(position);
    },
    getPositionCode(position) {
      return getPositionCode(this.currentUser.fieldPositionCodeId, position);
    },
    onImageLoadFailure(event) {
      event.target.src = "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png";
    },
    async loadNations() {
      const nationsResponse = await CountryService.getAll();
      this.nations = _.chain(nationsResponse.data).map(n => {
        n.textTranslated = n.code ? this.$t(`iso.${n.code.toUpperCase()}`) : '';
        return n
      }).filter(n => n.textTranslated).orderBy(['textTranslated'],['asc']).value();
    },
    async loadLeagues() {
      const leaguesResponse = await LeagueService.getAllLeagues();
      this.leagues = leaguesResponse.data;
    },
    getDefaultPositionCode(position) {
      //1: Driblab/Default positions
      return getPositionCode(1, position);
    },
    handleShowTeamForm() {
      this.showTeamForm = !this.showTeamForm;
    },
    handleShowLeagueForm() {
      this.showLeagueForm = !this.showLeagueForm;
    },
    calculatePlayerAge(dob) {
      const momentDob = moment(this.player.dob, 'YYYY-MM-DD');
      const today = moment();
      return today.diff(momentDob, 'years');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/player/AddPlayerModal.vue